import { gql } from "@apollo/client";

export const getAssetsTags = gql`
  query GetAssetsTags($Id: ID) {
    Account(Id: $Id) {
      Id
      AssetsTags
    }
  }
`;
